import {DropDownItem} from "../general/dropdownItem.model";

export class WorkflowDropdownItem extends DropDownItem{
    entityId: any;
    entity: WorkflowDropdownItemEntity;
    // RobertWorkflow rows only: the TP services (workflow order) a click selects; robertDisabled rows are
    // rendered grayed/unclickable (some Robert step has no ticked+mapped TP service).
    robertMappedServiceIds?: number[];
    robertDisabled?: boolean;
}

export class WorkflowDropdownValue{
    workflows: number[];
    workflowSteps: number[];
}

export enum WorkflowDropdownItemEntity{
    Workflow = 'workflow',
    WorkflowStep = 'workflowStep',
    // Also the dropdown group key: groups sort alphabetically (groupDropdownOptions), so 'workflowRobert'
    // deliberately lands the section between 'workflow' and 'workflowStep'.
    RobertWorkflow = 'workflowRobert'
}

